"use client";
import { Badge } from "@/components/ui/badge";
import { useTranslation } from "@/hooks/useLanguage";

import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export const Features = () => {
  const { t } = useTranslation();
  const features = t("features.features_list");
  const featureList = t("features.feature_list_items");

  // Ensure featureList and features are always arrays
  const safeFeatureList = Array.isArray(featureList) ? featureList : [];
  const safeFeatures = Array.isArray(features) ? features : [];

  return (
    <section id="features" className="container py-24 sm:py-32 space-y-8">
      <h2 className="text-3xl lg:text-4xl font-bold md:text-center">
        {t("features.title_1")}{" "}
        <span className="bg-gradient-to-b from-primary/60 to-primary text-transparent bg-clip-text">
          {t("features.title_1_span")}
        </span>
      </h2>

      {/* Feature badges */}
      <div className="flex flex-wrap md:justify-center gap-4">
        {safeFeatureList.map((feature) => (
          <div key={feature}>
            <Badge variant="secondary" className="text-sm">
              {feature}
            </Badge>
          </div>
        ))}
      </div>

      {/* Feature cards */}
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {safeFeatures.map(({ title, description }) => (
          <Card key={title}>
            <CardHeader>
              <CardTitle>{title}</CardTitle>
            </CardHeader>

            <CardContent>{description}</CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
};
